<template>
  <footer class="footer d-flex align-items-end">
    <div class="container">
      <ul class="list-inline d-flex">
        <li class="list-inline-item">&copy; Comstream AB {{ getCurrentYear }}</li>
        <li class="list-inline-item">
          <router-link :to="{ name: 'integrity' }">Integrity Policy</router-link>
        </li>
        <li class="list-inline-item">
          <router-link :to="{ name: 'about-us' }">About us</router-link>
        </li>
        <li class="list-inline-item">
          <router-link :to="{ name: 'contact' }">Contact</router-link>
        </li>
        <li class="list-inline-item last">
          <router-link :to="{ name: 'recruiting-services' }">Services</router-link>
        </li>
        <li class="list-inline-item ml-auto last">
          Follow us:
          <a href="https://www.facebook.com/comstream" target="_blank" rel="nofollow"
            ><i class="fab fa-facebook-square"></i
          ></a>
          <a href="https://www.linkedin.com/company/comstream/" target="_blank" rel="nofollow"
            ><i class="fab fa-linkedin"></i
          ></a>
        </li>
      </ul>
    </div>
    <cookie-law
      buttonText="Accept"
      :buttonDecline="true"
      buttonDeclineText="Reject Optional Cookies"
    >
      <div slot="message">
        We use cookies to make our site work. Cookies are used to improve user experience,
        personalize content, and analyze website traffic. By clicking “Accept,” you agree to
        <router-link :to="{ name: 'integrity' }"
          >Jobshark's Integrity Policy and User Conditions.</router-link
        >
      </div>
    </cookie-law>
  </footer>
</template>

<script>
import CookieLaw from 'vue-cookie-law';
export default {
  components: {
    CookieLaw,
  },
  computed: {
    getCurrentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  height: 350px;
  background: url('../../../public/img/homepage/footer-bg.png');
  background-size: cover;
  text-transform: uppercase;
  color: #fff;
  .container {
    max-width: 1320px;
  }
  a {
    text-decoration: none;
    color: #fff;
  }
  .list-inline {
    li {
      position: relative;
      margin-right: 25px;
      font-size: 14px;
      &:after {
        content: '';
        position: absolute;
        right: -13px;
        top: 0;
        width: 1px;
        height: 100%;
        background: #fff;
      }
      &.last {
        &:after {
          display: none;
        }
      }
      i {
        margin-left: 8px;
        font-size: 18px;
      }
    }
  }
}
@media only screen and (max-width: 576px) {
  .footer {
    background-position: bottom left !important;
    .list-inline {
      flex-wrap: wrap;
      li {
        display: block;
        width: 50%;
        margin-bottom: 6px;
        margin-right: 0;
        &:after {
          display: none;
        }
        &:first-of-type {
          order: 5;
        }
        &:nth-of-type(2) {
          order: 5;
        }
      }
    }
  }
}
</style>
